/*
 *
 * Attendance reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_ATTENDANCE,
  LOAD_COURSE,
  LOAD_COURSE_SUCCESS,
  LOAD_COURSE_ERROR,
  LOAD_COURSES,
  LOAD_COURSES_SUCCESS,
  LOAD_COURSES_ERROR,
  UPDATE_COURSE,
  UPDATE_COURSE_SUCCESS,
  UPDATE_COURSE_ERROR,
  /* DELETE_ATTENDANCE,
  DELETE_ATTENDANCE_SUCCESS,
  DELETE_ATTENDANCE_ERROR, */
} from './constants';

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  itemsList: [],
  options: false,
};

/* eslint-disable default-case, no-param-reassign */
const attendanceReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_ATTENDANCE:
        return initialState;
      
      case LOAD_COURSES:
        draft.loading = true;
        draft.error = false;
        draft.firstRender = true;
        draft.itemsList = [];
        draft.options = action.options;
        break;

      case LOAD_COURSES_SUCCESS:
        draft.loading = false;
        draft.itemsList = action.itemsList;
        break;

      case LOAD_COURSES_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.itemsList = [];
        draft.options = false;
        break;

    /*  case CHANGE_ATTENDANCE_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // DELETE
      case DELETE_ATTENDANCE:
        draft.loading = true;
        draft.id = action.id;
        break;

      case DELETE_ATTENDANCE_SUCCESS:
        draft.loading = false;
        draft.deleteSuccessful = true;
        break; */
    }
  });

export default attendanceReducer;
